import { BROWSER_CAPABILITIES } from 'utils/browserCapabilities';

export const getAudioTrackConstraints: (
  constraints: MediaTrackConstraints | boolean,
) => MediaTrackConstraints | boolean = (constraints) => {
  if (!constraints) {
    return false;
  }

  if (typeof constraints === 'boolean') {
    return constraints;
  }

  if (constraints.deviceId) {
    const deviceId: ConstrainDOMString = BROWSER_CAPABILITIES.safari
      ? constraints.deviceId
      : ({ exact: constraints.deviceId } as ConstrainDOMString);

    return {
      deviceId,
      channelCount: 2,
    };
  }

  return false;
};
